import axios from 'axios';
import BaseApi from './base-api';

class ProjectAdvancedDocumentsApi extends BaseApi {
  createAdvancedDocumentsFolder(projectId, values) {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    let apiPayload = new FormData();
    apiPayload.append('advanced_documents[folder_name]', values.folderName);
    apiPayload.append('advanced_documents[prefix]', values.prefix);
    return axios
      .post(
        `${this.baseUrl}/projects/${projectId}/advanced_documents/create_folder`,
        apiPayload,
        headers
      )
      .then((response) => {
        return { ok: true };
      })
      .catch((error) => {
        return { ok: false, errors: error.response.data.errors };
      });
  }

  renameAdvancedDocumentsFolder(projectId, values) {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    let apiPayload = new FormData();
    apiPayload.append('advanced_documents[folder_name]', values.folderName);
    apiPayload.append('advanced_documents[prefix]', values.prefix);
    apiPayload.append(
      'advanced_documents[old_folder_name]',
      values.oldFolderName
    );

    return axios
      .post(
        `${this.baseUrl}/projects/${projectId}/advanced_documents/rename_folder`,
        apiPayload,
        headers
      )
      .then((response) => {
        return { ok: true };
      })
      .catch((error) => {
        return { ok: false, errors: error.response.data.errors };
      });
  }

  uploadAdvancedDocuments(projectId, values) {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    let apiPayload = new FormData();

    apiPayload.append('advanced_documents[prefix]', values.prefix);
    values.documents.forEach((doc, index) => {
      apiPayload.append(
        `advanced_documents[documents][${index}][document]`,
        doc.file,
        doc.name
      );
    });
    return axios
      .post(
        `${this.baseUrl}/projects/${projectId}/advanced_documents/upload_documents`,
        apiPayload,
        headers
      )
      .then((response) => {
        return { ok: true };
      })
      .catch((error) => {
        return { ok: false, errors: error.response.data.errors };
      });
  }

  deleteAdvancedDocuments(projectId, values) {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    let apiPayload = new FormData();

    apiPayload.append('advanced_documents[prefix]', values.prefix);
    values.documents.forEach((doc, index) => {
      apiPayload.append(
        `advanced_documents[documents][${index}][document]`,
        doc
      );
    });
    values.folders.forEach((folder, index) => {
      apiPayload.append(
        `advanced_documents[folders][${index}][folder]`,
        folder
      );
    });

    return axios
      .post(
        `${this.baseUrl}/projects/${projectId}/advanced_documents/delete_files_and_folders`,
        apiPayload,
        headers
      )
      .then((response) => {
        return { ok: true };
      })
      .catch((error) => {
        return { ok: false, errors: error.response.data.errors };
      });
  }

  downloadAdvancedDocumentsFolder(values) {
    return axios
      .post(`${process.env.REACT_APP_GATEWAY_API_URL}/download_folders`, {
        selectedFolders: values.selectedFolders,
        bucket: values.bucket,
        message: values.message,
        subject: values.subject,
        recipients: values.recipients,
        rootFolder: values.rootFolder,
        selectedFiles: values.selectedFiles,
      })
      .then((response) => {
        return { ok: true };
      })
      .catch((error) => {
        return { ok: false, errors: error.response };
      });
  }

  moveAdvancedDocumentsFolder(projectId, values) {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    let apiPayload = new FormData();
    apiPayload.append(
      'advanced_documents[selected_object]',
      values.selectedObject
    );
    apiPayload.append(
      'advanced_documents[selected_destination',
      values.selectedDestination
    );
    apiPayload.append('advanced_documents[parent_folder', values.parentFolder);

    return axios
      .post(
        `${this.baseUrl}/projects/${projectId}/advanced_documents/move_object`,
        apiPayload,
        headers
      )
      .then((response) => {
        return { ok: true };
      })
      .catch((error) => {
        return { ok: false, errors: error.response.data.errors };
      });
  }
}

export const projectAdvancedDocumentsApi = new ProjectAdvancedDocumentsApi();



// WEBPACK FOOTER //
// ./src/services/api/project-advanced-documents-api.js